/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  skipNav: {
    id: 'skipNav_skipNav',
    defaultMessage: 'Skip to main content',
  },
  headerHomeLabel: {
    id: 'Header_HomeLabel',
    defaultMessage: 'Home',
  },
  headerMenuLabel: {
    id: 'Header_MenuLabel',
    defaultMessage: 'Menu',
  },
  /* BEGIN PR-7537 ZPK - Changing tab message from 'Benefits' to 'Apply' */
  headerBenefitsLabel: {
    id: 'Header_BenefitsLabel',
    defaultMessage: 'Apply',
  },
  /* END PR-7537 ZPK - Changing tab message from 'Benefits' to 'Apply' */
  headerDashboardLabel: {
    id: 'Header_DashboardLabel',
    defaultMessage: 'Dashboard',
  },
  headerYourBenefitsLabel: {
    id: 'Header_YourBenefitsLabel',
    defaultMessage: 'View your Benefits',
  },
  headerAppealsLabel: {
    id: 'Header_AppealsLabel',
    defaultMessage: 'Appeals',
  },
  headerNoticesLabel: {
    id: 'Header_NoticesLabel',
    defaultMessage: 'Notices',
  },
  headerHelpLabel: {
    id: 'Header_HelpLabel',
    defaultMessage: 'Find help',
  },
  headerYourAccountLabel: {
    id: 'Header_YourAccountLabel',
    defaultMessage: 'Your Account',
  },
  headerFAQLabel: {
    id: 'Header_FAQLabel',
    defaultMessage: 'FAQs',
  },
  headerContactUsLabel: {
    id: 'Header_ContactUsLabel',
    defaultMessage: 'Contact us',
  },
  headerLandingPageTitle: {
    id: 'Header_LandingPageTitle',
    // updated page title for SDBEES
    defaultMessage: 'SD BEES',
  },
  headerLogInText: {
    id: 'Header_LogInText',
    defaultMessage: 'Log in',
  },
  headerSignUpText: {
    id: 'Header_SignUpText',
    defaultMessage: 'Sign up',
  },
  headerLogOutText: {
    id: 'Header_LogOutText',
    defaultMessage: 'Log out',
  },
  headerProfileText: {
    id: 'Header_ProfileText',
    defaultMessage: 'Report Changes',
  },
  headerYourProfileText: {
    id: 'Header_YourProfileText',
    defaultMessage: 'Your profile',
  },
  headerMenuInfoText: {
    id: 'Header_MenuInfoText',
    defaultMessage: 'Selecting {menuOptionText} will open a new page',
  },
  headerSkipNavigationText: {
    id: 'headerSkipNavigationText',
    defaultMessage: 'Skip Navigation',
  },
  headerYourVerificationsText: {
    id: 'Header_YourVerificationsText',
    defaultMessage: 'Documents',
  },
  /* BEGIN SD-1066 YP - Adding 'Local Office' tab message */
  headerLocalOfficeLabel: {
    id: 'Header_LocalOfficeLabel',
    defaultMessage: 'Local Office',
  },
  /* END SD-1066 YP - Adding 'Local Office' tab message  */
  /** Begin - SD-6478 - Moving hard-coded values to message file and correcting text */
  cabinetSecretaryName: {
    id: 'Cabinet_SecretaryName',
    defaultMessage: 'Matthew Althoff',
  },
  cabinetSecretaryLabel: {
    id: 'Cabinet_SecretaryLabel',
    defaultMessage: 'Cabinet Secretary',
  },
  /** END - SD-6478 - Moving hard-coded values to message file */
  headerSettingsLabel: {
    id: 'Header_SettingsLabel',
    defaultMessage: 'Settings',
  },
});
